import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  ReportDesignItemSelectbox,
  ReportDesignItemSelectboxConfig
} from "src/app/modules/bootstrap/modules/report/report-design-item";

@Component({
  selector: "snt-report-designer-selectbox",
  templateUrl: "report-designer-selectbox.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportDesignerSelectboxComponent implements OnInit {
  formData: { title: string; options: string } = {
    title: "",
    options: ""
  };

  @Input()
  item: ReportDesignItemSelectbox | undefined;

  @Input()
  level!: number;

  @Input()
  parentName!: string;

  @Input()
  readonly: boolean = false;

  @Output()
  config: EventEmitter<ReportDesignItemSelectboxConfig> = new EventEmitter();

  ngOnInit(): void {
    this.formData.title = this.item?.config?.title || "";
    this.formData.options = this.item?.config?.options || "";
  }

  onFieldDataChanged(): void {
    this.config.emit({
      ...this.item!.config,
      ...this.formData
    });
  }

  async renderPdfObject(): Promise<Record<string, unknown>> {
    return {
      type: "selectbox",
      config: {
        title: this.formData.title,
        options: this.formData.options
      }
    };
  }
}
